export const languageNameToCode = {
    Afar: "aa",
    Abkhazian: "ab",
    Avestan: "ae",
    Afrikaans: "af",
    Akan: "ak",
    Amharic: "am",
    Aragonese: "an",
    Arabic: "ar",
    Assamese: "as",
    Avaric: "av",
    Aymara: "ay",
    Azerbaijani: "az",
    Bashkir: "ba",
    Belarusian: "be",
    Bulgarian: "bg",
    "Bihari": "bh",
    Bislama: "bi",
    Bambara: "bm",
    Bengali: "bn",
    Tibetan: "bo",
    Breton: "br",
    Bosnian: "bs",
    Catalan: "ca",
    Chechen: "ce",
    Chamorro: "ch",
    Corsican: "co",
    Cree: "cr",
    Czech: "cs",
    Chuvash: "cv",
    Welsh: "cy",
    Danish: "da",
    German: "de",
    "Divehi; Maldivian": "dv",
    Dzongkha: "dz",
    Ewe: "ee",
    Greek: "el",
    English: "en",
    Esperanto: "eo",
    Spanish: "es",
    Estonian: "et",
    Basque: "eu",
    Persian: "fa",
    Fulah: "ff",
    Finnish: "fi",
    Fijian: "fj",
    Faroese: "fo",
    French: "fr",
    "Western Frisian": "fy",
    Irish: "ga",
    Gaelic: "gd",
    Galician: "gl",
    Guarani: "gn",
    Gujarati: "gu",
    Manx: "gv",
    Hausa: "ha",
    Hebrew: "he",
    Hindi: "hi",
    "Hiri Motu": "ho",
    Croatian: "hr",
    "Haitian Creole": "ht",
    Hungarian: "hu",
    Armenian: "hy",
    Herero: "hz",
    "Interlingua": "ia",
    Indonesian: "id",
    Igbo: "ig",
    Inupiaq: "ik",
    Ido: "io",
    Icelandic: "is",
    Italian: "it",
    Inuktitut: "iu",
    Japanese: "ja",
    Javanese: "jv",
    Georgian: "ka",
    Kongo: "kg",
    "Kikuyu; Gikuyu": "ki",
    "Kuanyama; Kwanyama": "kj",
    Kazakh: "kk",
    "Kalaallisut; Greenlandic": "kl",
    "Central Khmer": "km",
    Kannada: "kn",
    Korean: "ko",
    Kanuri: "kr",
    Kashmiri: "ks",
    Kurdish: "ku",
    Komi: "kv",
    Cornish: "kw",
    "Kirghiz; Kyrgyz": "ky",
    Latin: "la",
    Luxembourgish: "lb",
    Ganda: "lg",
    Lingala: "ln",
    Lao: "lo",
    Lithuanian: "lt",
    "Luba-Katanga": "lu",
    Latvian: "lv",
    Malagasy: "mg",
    Marshallese: "mh",
    Maori: "mi",
    Macedonian: "mk",
    Malayalam: "ml",
    Mongolian: "mn",
    Marathi: "mr",
    Malay: "ms",
    Maltese: "mt",
    Burmese: "my",
    Nauru: "na",
    Nepali: "ne",
    Ndonga: "ng",
    Dutch: "nl",
    Norwegian: "no",
    Navajo: "nv",
    Occitan: "oc",
    Ojibwa: "oj",
    Oromo: "om",
    Oriya: "or",
    Ossetian: "os",
    Punjabi: "pa",
    Pali: "pi",
    Polish: "pl",
    Portuguese: "pt",
    Quechua: "qu",
    Romansh: "rm",
    Rundi: "rn",
    Moldavian: "ro",
    Russian: "ru",
    Kinyarwanda: "rw",
    Sanskrit: "sa",
    Sardinian: "sc",
    Sindhi: "sd",
    Sango: "sg",
    "Sinhala; Sinhalese": "si",
    Slovak: "sk",
    Slovenian: "sl",
    Samoan: "sm",
    Shona: "sn",
    Somali: "so",
    Albanian: "sq",
    Serbian: "sr",
    Swati: "ss",
    "Sotho, Southern": "st",
    Sundanese: "su",
    Swedish: "sv",
    Swahili: "sw",
    Tamil: "ta",
    Telugu: "te",
    Tajik: "tg",
    Thai: "th",
    Tigrinya: "ti",
    Turkmen: "tk",
    Tagalog: "tl",
    Tswana: "tn",
    Tonga: "to",
    Turkish: "tr",
    Tsonga: "ts",
    Tatar: "tt",
    Twi: "tw",
    Tahitian: "ty",
    "Uighur; Uyghur": "ug",
    Ukrainian: "uk",
    Urdu: "ur",
    Uzbek: "uz",
    Venda: "ve",
    Vietnamese: "vi",
    "Volapük": "vo",
    Walloon: "wa",
    Wolof: "wo",
    Xhosa: "xh",
    Yiddish: "yi",
    Yoruba: "yo",
    "Zhuang; Chuang": "za",
    Chinese: "zh",
    Zulu: "zu"
};

export const languageOptions = ["Abkhazian", "Afar", "Afrikaans", "Akan", "Albanian", "Amharic", "Arabic", "Aragonese", "Armenian", "Assamese", "Avaric", "Avestan", "Aymara", "Azerbaijani", "Bambara", "Bashkir", "Basque", "Belarusian", "Bengali", "Bihari", "Bislama", "Bosnian", "Breton", "Bulgarian", "Burmese", "Catalan", "Central Khmer", "Chamorro", "Chechen", "Chinese", "Chuvash", "Cornish", "Corsican", "Cree", "Croatian", "Czech", "Danish", "Divehi; Maldivian", "Dutch", "Dzongkha", "English", "Esperanto", "Estonian", "Ewe", "Faroese", "Fijian", "Finnish", "French", "Fulah", "Gaelic", "Galician", "Ganda", "Georgian", "German", "Greek", "Guarani", "Gujarati", "Haitian Creole", "Hausa", "Hebrew", "Herero", "Hindi", "Hiri Motu", "Hungarian", "Icelandic", "Ido", "Igbo", "Indonesian", "Interlingua", "Inuktitut", "Inupiaq", "Irish", "Italian", "Japanese", "Javanese", "Kalaallisut; Greenlandic", "Kannada", "Kanuri", "Kashmiri", "Kazakh", "Kikuyu; Gikuyu", "Kinyarwanda", "Kirghiz; Kyrgyz", "Komi", "Kongo", "Korean", "Kuanyama; Kwanyama", "Kurdish", "Lao", "Latin", "Latvian", "Lingala", "Lithuanian", "Luba-Katanga", "Luxembourgish", "Macedonian", "Malagasy", "Malay", "Malayalam", "Maltese", "Manx", "Maori", "Marathi", "Marshallese", "Moldavian", "Mongolian", "Nauru", "Navajo", "Ndonga", "Nepali", "Norwegian", "Occitan", "Ojibwa", "Oriya", "Oromo", "Ossetian", "Pali", "Persian", "Polish", "Portuguese", "Punjabi", "Quechua", "Romansh", "Rundi", "Russian", "Samoan", "Sango", "Sanskrit", "Sardinian", "Serbian", "Shona", "Sindhi", "Sinhala; Sinhalese", "Slovak", "Slovenian", "Somali", "Sotho, Southern", "Spanish", "Sundanese", "Swahili", "Swati", "Swedish", "Tagalog", "Tahitian", "Tajik", "Tamil", "Tatar", "Telugu", "Thai", "Tibetan", "Tigrinya", "Tonga", "Tsonga", "Tswana", "Turkish", "Turkmen", "Twi", "Uighur; Uyghur", "Ukrainian", "Urdu", "Uzbek", "Venda", "Vietnamese", "Volapük", "Walloon", "Welsh", "Western Frisian", "Wolof", "Xhosa", "Yiddish", "Yoruba", "Zhuang; Chuang", "Zulu"];

export const languageCodeToName = {
    aa: "Afar",
    ab: "Abkhazian",
    ae: "Avestan",
    af: "Afrikaans",
    ak: "Akan",
    am: "Amharic",
    an: "Aragonese",
    ar: "Arabic",
    as: "Assamese",
    av: "Avaric",
    ay: "Aymara",
    az: "Azerbaijani",
    ba: "Bashkir",
    be: "Belarusian",
    bg: "Bulgarian",
    bh: "Bihari",
    bi: "Bislama",
    bm: "Bambara",
    bn: "Bengali",
    bo: "Tibetan",
    br: "Breton",
    bs: "Bosnian",
    ca: "Catalan",
    ce: "Chechen",
    ch: "Chamorro",
    co: "Corsican",
    cr: "Cree",
    cs: "Czech",
    cv: "Chuvash",
    cy: "Welsh",
    da: "Danish",
    de: "German",
    dv: "Divehi; Maldivian",
    dz: "Dzongkha",
    ee: "Ewe",
    el: "Greek",
    en: "English",
    eo: "Esperanto",
    es: "Spanish",
    et: "Estonian",
    eu: "Basque",
    fa: "Persian",
    ff: "Fulah",
    fi: "Finnish",
    fj: "Fijian",
    fo: "Faroese",
    fr: "French",
    fy: "Western Frisian",
    ga: "Irish",
    gd: "Gaelic",
    gl: "Galician",
    gn: "Guarani",
    gu: "Gujarati",
    gv: "Manx",
    ha: "Hausa",
    he: "Hebrew",
    hi: "Hindi",
    ho: "Hiri Motu",
    hr: "Croatian",
    ht: "Haitian Creole",
    hu: "Hungarian",
    hy: "Armenian",
    hz: "Herero",
    ia: "Interlingua",
    id: "Indonesian",
    ig: "Igbo",
    ik: "Inupiaq",
    io: "Ido",
    is: "Icelandic",
    it: "Italian",
    iu: "Inuktitut",
    ja: "Japanese",
    jv: "Javanese",
    ka: "Georgian",
    kg: "Kongo",
    ki: "Kikuyu; Gikuyu",
    kj: "Kuanyama; Kwanyama",
    kk: "Kazakh",
    kl: "Kalaallisut; Greenlandic",
    km: "Central Khmer",
    kn: "Kannada",
    ko: "Korean",
    kr: "Kanuri",
    ks: "Kashmiri",
    ku: "Kurdish",
    kv: "Komi",
    kw: "Cornish",
    ky: "Kirghiz; Kyrgyz",
    la: "Latin",
    lb: "Luxembourgish",
    lg: "Ganda",
    ln: "Lingala",
    lo: "Lao",
    lt: "Lithuanian",
    lu: "Luba-Katanga",
    lv: "Latvian",
    mg: "Malagasy",
    mh: "Marshallese",
    mi: "Maori",
    mk: "Macedonian",
    ml: "Malayalam",
    mn: "Mongolian",
    mr: "Marathi",
    ms: "Malay",
    mt: "Maltese",
    my: "Burmese",
    na: "Nauru",
    ne: "Nepali",
    ng: "Ndonga",
    nl: "Dutch",
    no: "Norwegian",
    nv: "Navajo",
    oc: "Occitan",
    oj: "Ojibwa",
    om: "Oromo",
    or: "Oriya",
    os: "Ossetian",
    pa: "Punjabi",
    pi: "Pali",
    pl: "Polish",
    pt: "Portuguese",
    qu: "Quechua",
    rm: "Romansh",
    rn: "Rundi",
    ro: "Moldavian",
    ru: "Russian",
    rw: "Kinyarwanda",
    sa: "Sanskrit",
    sc: "Sardinian",
    sd: "Sindhi",
    sg: "Sango",
    si: "Sinhala; Sinhalese",
    sk: "Slovak",
    sl: "Slovenian",
    sm: "Samoan",
    sn: "Shona",
    so: "Somali",
    sq: "Albanian",
    sr: "Serbian",
    ss: "Swati",
    st: "Sotho, Southern",
    su: "Sundanese",
    sv: "Swedish",
    sw: "Swahili",
    ta: "Tamil",
    te: "Telugu",
    tg: "Tajik",
    th: "Thai",
    ti: "Tigrinya",
    tk: "Turkmen",
    tl: "Tagalog",
    tn: "Tswana",
    to: "Tonga",
    tr: "Turkish",
    ts: "Tsonga",
    tt: "Tatar",
    tw: "Twi",
    ty: "Tahitian",
    ug: "Uighur; Uyghur",
    uk: "Ukrainian",
    ur: "Urdu",
    uz: "Uzbek",
    ve: "Venda",
    vi: "Vietnamese",
    vo: "Volapük",
    wa: "Walloon",
    wo: "Wolof",
    xh: "Xhosa",
    yi: "Yiddish",
    yo: "Yoruba",
    za: "Zhuang; Chuang",
    zh: "Chinese",
    zu: "Zulu"
};